module.exports = __webpack_public_path__ + "static/media/macbook@2x.f6cc7ac9.png";